import { ReactElement } from "react";
import { T } from "react-translator-component";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import dayjs from "../../../util/dayjs";
import { convertUserImage } from "../../../util/utils";
import DisplayModal from "../DisplayModal";
import SafeTextWithLinks from "../SafeTextWithLinks";

interface Props {
  open: boolean;
  data: any;
  onClose: () => void;
}

export default function DetailsModal({open, data, onClose}: Props): ReactElement {
  const gridItem = (title: string, content: ReactElement | string) => (
    <>
      <Grid item component={"dt"} xs={2}>{title}</Grid>
      <Grid item component={"dd"} xs={10}>{content}</Grid>
    </>
  );

  if (!data) {
    return (<></>);
  }
  return (
    <DisplayModal title={`${T("mng_user_notifications_details")}`} open={open} onClose={onClose} sx={styles.container}>
      <Box sx={styles.data}>
        <Grid container component={"dl"}>
          {gridItem(
            T("mng_user_notifications_message_to"),
            (
              <Box sx={styles.data.to}>
                <Avatar
                  src={convertUserImage(data.user.image)}
                />
                <Typography>{data.user.nickname}</Typography>
              </Box>
            )
          )}
          {gridItem(
            T("mng_user_notifications_message_sent_date"),
            dayjs(data.notification.created_at).format("YYYY/MM/DD HH:mm")
          )}
          {gridItem(T("mng_user_notifications_message_title"), data.notification.title)}
          {gridItem(T("mng_user_notifications_message_summary"), data.notification.summary)}
          {gridItem(
            T("mng_user_notifications_message_details"), 
            <SafeTextWithLinks text={data.notification.details} />
          )}
        </Grid>
      </Box>
    </DisplayModal>
  );
}

const styles = {
  container: {
    maxWidth: "85%"
  },

  data: {
    "& dl": {
      maxHeight: "calc(100vh*0.9*0.7 - 90px)",
      overflowY: "auto" as const,
      border: "1px solid black",
    },
    "& dt": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      whiteSpace: "nowrap",
      borderRight: "1px solid black",
      borderBottom: "1px solid black"
    },
    "& dd": {
      p: 1,
      borderBottom: "1px solid black"
    },
    "& dt:last-of-type": {
      borderBottom: "none"
    },
    "& dd:last-of-type": {
      borderBottom: "none"
    },
    to: {
      display: "flex",
      "& .MuiAvatar-root": {
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        objectFit: "cover",
        marginRight: 1
      },
      "& .MuiTypography-root": {
        display: "flex",
        alignItems: "center"
      }
    }
  }
}